export const TABLE_TYPES = {
    SQUARE: "SQUARE",
    RECTANGLE: "RECTANGLE",
    OVAL: "OVAL",
    ROUND: "ROUND",
}

export const TABLE_TYPES_LABELS = {
    [TABLE_TYPES.SQUARE]: "settings:table_types.square",
    [TABLE_TYPES.RECTANGLE]: "settings:table_types.rectangle",
    [TABLE_TYPES.OVAL]: "settings:table_types.oval",
    [TABLE_TYPES.ROUND]: "settings:table_types.round",
};

export const TABLE_TYPE_OPTIONS = Object.entries(TABLE_TYPES_LABELS)
    .map(([value, text]) => ({
        key: value,
        value,
        text,
    }));

// legacy
export const tableTypeText = TABLE_TYPES_LABELS;


// WEBPACK FOOTER //
// ./src/constants/tables.js